import React from "react"
import PropTypes from "prop-types"

export const FilterIcon = ({ height = 24, width = 24, fill = "var(--color-primary)", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 60 60" fill="none">
    <g filter="url(#filter0_d_38772_225146)">
      <rect x="10.75" y="9.75" width="38.5" height="38.5" rx="19.25" stroke="currentcolor" strokeWidth="1.5" shapeRendering="crispEdges" />
      <path
        d="M28 19C26.7068 19 25.6049 19.8427 25.1875 21H20V23H25.1875C25.6049 24.1573 26.7068 25 28 25C29.645 25 31 23.645 31 22C31 20.355 29.645 19 28 19ZM28 21C28.5641 21 29 21.4359 29 22C29 22.5641 28.5641 23 28 23C27.4359 23 27 22.5641 27 22C27 21.4359 27.4359 21 28 21ZM33 21V23H40V21H33ZM33 26C31.7068 26 30.6049 26.8427 30.1875 28H20V30H30.1875C30.6049 31.1573 31.7068 32 33 32C34.645 32 36 30.645 36 29C36 27.355 34.645 26 33 26ZM33 28C33.5641 28 34 28.4359 34 29C34 29.5641 33.5641 30 33 30C32.4359 30 32 29.5641 32 29C32 28.4359 32.4359 28 33 28ZM38 28V30H40V28H38ZM25 33C23.7068 33 22.6049 33.8427 22.1875 35H20V37H22.1875C22.6049 38.1573 23.7068 39 25 39C26.645 39 28 37.645 28 36C28 34.355 26.645 33 25 33ZM25 35C25.5641 35 26 35.4359 26 36C26 36.5641 25.5641 37 25 37C24.4359 37 24 36.5641 24 36C24 35.4359 24.4359 35 25 35ZM30 35V37H40V35H30Z"
        fill={fill}
      />
    </g>
    <defs>
      <filter id="filter0_d_38772_225146" x="0" y="0" width={width} height={height} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0762025 0 0 0 0 0.191713 0 0 0 0 0.393856 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_38772_225146" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_38772_225146" result="shape" />
      </filter>
    </defs>
  </svg>
)

FilterIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string
}
